import BaseRepository from '@/api/repositories/BaseRepository';

class LawyerOfficeRepository extends BaseRepository {
	get endpoint() {
		return 'api/lawyeroffices';
	}
}

export default new LawyerOfficeRepository();
